var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiveChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#275180",
    strokeWidth: 1.5,
    d: "M5 20.4A1 1 0 0 0 5 19 9.9 9.9 0 0 1 3.7 6.4 10 10 0 1 1 12 22H3.3L5 20.4ZM15.8 12a1 1 0 1 0 2 0 1 1 0 0 0-2 0ZM11 12a1 1 0 1 0 2 0 1 1 0 0 0-2 0Zm-4.7 0a1 1 0 1 0 1.9 0 1 1 0 0 0-2 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveChat);
export default __webpack_public_path__ + "static/media/live-chat.32e45cfa68cbfdc449debce4ee124950.svg";
export { ForwardRef as ReactComponent };